"use client";

import { c as _c } from "react/compiler-runtime";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import * as React from "react";
import { useIsMobile } from "@justhome/common/hooks";
import clsx from "clsx";
const Tabs = t0 => {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const t1 = props as React.ComponentProps<typeof TabsPrimitive.Root>;
  let t2;
  if ($[2] !== t1) {
    t2 = <TabsPrimitive.Root {...t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
const TabsList = React.forwardRef<React.ElementRef<typeof TabsPrimitive.List>, React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>>((t0, ref) => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = clsx("flex gap-xs data-[orientation=horizontal]:border-b data-[orientation=bottom]:border-t border-neutral-50", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== ref || $[7] !== t1) {
    t2 = <div className="overflow-x-auto m:overflow-x-visible"><TabsPrimitive.List ref={ref} className={t1} {...props} /></div>;
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});
TabsList.displayName = TabsPrimitive.List.displayName;
const TabsTrigger = React.forwardRef<React.ElementRef<typeof TabsPrimitive.Trigger>, React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & {
  size?: "sm" | "md";
}>((t0, ref) => {
  const $ = _c(17);
  let className;
  let onClick;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      onClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = onClick;
    $[3] = props;
    $[4] = t1;
  } else {
    className = $[1];
    onClick = $[2];
    props = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? "md" : t1;
  const isMobile = useIsMobile();
  let t2;
  if ($[5] !== isMobile || $[6] !== onClick) {
    t2 = e => {
      if (isMobile) {
        setTimeout(() => {
          (e.target as HTMLElement).scrollIntoView({
            behavior: "smooth",
            inline: "center"
          });
        }, 100);
      }
      onClick?.(e);
    };
    $[5] = isMobile;
    $[6] = onClick;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleClick = t2;
  const t3 = size === "md";
  const t4 = size === "sm";
  let t5;
  if ($[8] !== className || $[9] !== t3 || $[10] !== t4) {
    t5 = clsx("relative flex items-center justify-center pt-2xs pb-[7px] px-3xs", "disabled:pointer-events-none disabled:opacity-50", "focusable focus-visible:z-10", "data-[orientation=horizontal]:rounded-t-xs", "data-[orientation=bottom]:rounded-b-xs", "data-[orientation=vertical]:rounded-xs", "data-[state=active]:bg-primary-50 data-[state=active]:text-primary-800 data-[state=active]:border-primary-800 data-[state=inactive]:hover:bg-neutral-12", "data-[orientation=horizontal]:data-[state=active]:mb-[-1px] data-[orientation=horizontal]:data-[state=active]:pb-[6px]", "data-[orientation=bottom]:pb-2xs data-[orientation=bottom]:pt-[7px]", "data-[orientation=bottom]:data-[state=active]:mt-[-1px] data-[orientation=bottom]:data-[state=active]:pt-[6px]", "data-[orientation=vertical]:data-[state=active]:pl-[10px]", "data-[orientation=vertical]:data-[state=active]:border-l-[2px] data-[orientation=vertical]:rounded-l-none", "data-[orientation=horizontal]:data-[state=active]:border-b-[2px]", "data-[orientation=bottom]:data-[state=active]:border-t-[2px]", className, {
      "text-button-2": t3,
      "text-app-body-2": t4
    });
    $[8] = className;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== handleClick || $[13] !== props || $[14] !== ref || $[15] !== t5) {
    t6 = <TabsPrimitive.Trigger ref={ref} onClick={handleClick} className={t5} {...props} />;
    $[12] = handleClick;
    $[13] = props;
    $[14] = ref;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
});
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
const TabsContent = React.forwardRef<React.ElementRef<typeof TabsPrimitive.Content>, React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>>((t0, ref) => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = clsx("mt-2 ring-offset-none focus-visible:outline-none focus-visible:ring-none focus-visible:ring-neutral-none focus-visible:ring-offset-none", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== ref || $[7] !== t1) {
    t2 = <TabsPrimitive.Content ref={ref} className={t1} {...props} />;
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});
TabsContent.displayName = TabsPrimitive.Content.displayName;
export { Tabs, TabsContent, TabsList, TabsTrigger };